import React from 'react';
import {
  HomeIcon,
  CpuChipIcon,
  ChartBarIcon,
  EyeIcon,
  ArrowDownTrayIcon,
  KeyIcon,
  GlobeAltIcon,
  ChatBubbleLeftRightIcon,
  CommandLineIcon,
  DocumentTextIcon,
  ClipboardDocumentListIcon,
  Cog6ToothIcon,
  Squares2X2Icon,
  ArrowsRightLeftIcon,
  ExclamationTriangleIcon,
  LockClosedIcon,
  UsersIcon,
  ShieldCheckIcon,
  TagIcon,
  ClockIcon,
  PlusIcon,
  DocumentDuplicateIcon,
  CircleStackIcon,
  ListBulletIcon,
  BoltIcon,
  ChartPieIcon,
  SignalIcon,
  PuzzlePieceIcon,
} from '@heroicons/react/24/outline';

// Heroicons outline set has limited business-domain coverage; intentional icon
// reuse across keys (e.g. TagIcon for tags/analyticsTags/tagZone) — text labels
// in Sidebar disambiguate. Don't try to dedupe by adding new imports.
export const ICONS = {
  dashboard: HomeIcon,
  devices: CpuChipIcon,
  metrics: ChartBarIcon,
  monitoring: EyeIcon,
  firmware: ArrowDownTrayIcon,
  apiKeys: KeyIcon,
  webhooks: GlobeAltIcon,
  externalApi: ChatBubbleLeftRightIcon,
  commands: CommandLineIcon,
  deviceLogs: DocumentTextIcon,
  readerLogs: DocumentTextIcon,
  tasks: ClipboardDocumentListIcon,
  settings: Cog6ToothIcon,
  provisioning: Squares2X2Icon,
  stockMovements: ArrowsRightLeftIcon,
  discrepancies: ExclamationTriangleIcon,
  deviceLocks: LockClosedIcon,
  users: UsersIcon,
  certificates: ShieldCheckIcon,
  whitelist: DocumentDuplicateIcon,
  tags: TagIcon,
  events: ClockIcon,
  add: PlusIcon,
  templates: Squares2X2Icon,
  referenceLists: ListBulletIcon,
  mqttControl: BoltIcon,
  analyticsHealth: ChartPieIcon,
  analyticsStatus: SignalIcon,
  analyticsTags: TagIcon,
  analyticsGpi: BoltIcon,
  analyticsConnectivity: SignalIcon,
  analyticsCommands: CommandLineIcon,
  analyticsBoot: PuzzlePieceIcon,
  analyticsAnalysis: ChartBarIcon,
  analysisReports: ClipboardDocumentListIcon,
  reportsProductivity: ChartBarIcon,
  reportsUniqueItems: ClipboardDocumentListIcon,
  bling: CircleStackIcon,
  tagZone: TagIcon,
  approvals: ShieldCheckIcon,
  claimTokens: KeyIcon,
  configurations: Cog6ToothIcon,
  provisioningEvents: ClockIcon,
  provisioningDashboard: Squares2X2Icon,
};

export default function NavIcon({ name, className = 'h-5 w-5' }) {
  const Icon = ICONS[name];
  if (!Icon) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`[NavIcon] unknown icon name: "${name}"`);
    }
    return null;
  }
  return <Icon className={className} aria-hidden="true" />;
}
